<template>
    <div :class="[`rank-peple rank-peple${person.index}`]">
        <div class="rank-num">
            <template v-if="person.index > 3">
                {{ person.index > 99 ? '99+' : person.index }}
            </template>
            <img v-else-if="person.index == 1" src="@/assets/img/partner/top1-icon.png" />
            <img v-else-if="person.index == 2" src="@/assets/img/partner/top2-icon.png" />
            <img v-else-if="person.index == 3" src="@/assets/img/partner/top3-icon.png" />
        </div>
        <div class="rank-avatar"><img v-lazy="person.avatar" /></div>
        <div class="rank-name elipsis">
            {{ Object.keys(self).length ? decodeName(person.nickname) || '****' : encryptUsername(decodeName(person.nickname)) }}
        </div>
        <div class="rank-gold">
            <span class="mr-[5px]">{{ curSymbol[wallet?.currency] }} </span> {{ formatNumber(person.score == -1 ? 0 : person.score || 0) }}
        </div>
    </div>
</template>
<script lang="ts" setup>
import { useBaseStore } from '@/stores'
import { storeToRefs } from 'pinia'
import { decodeName, encryptUsername } from '@/utils'
import { formatNumber } from '@/utils/toolsValidate'

const { userInfo, wallet, curSymbol, partnerInfo } = storeToRefs(useBaseStore())

const props = defineProps({
    item: {
        type: Object,
        default: () => ({}),
    },
    self: {
        type: Object,
        default: () => ({}),
    },
    isSelf: {
        type: Boolean,
        default: () => false,
    },
    index: {
        type: Number,
        default: () => 0,
    },
})

const person = computed<{
    nickname: string
    avatar: string
    index: number
    uid: number
    score: number
}>(() => {
    if (props.isSelf) {
        const index = props.self.index
        return {
            score: +props.self.score,
            index: ~index ? index + 1 : 100,
            avatar: partnerInfo.value.avatar || userInfo.value.avatar,
            nickname: userInfo.value.nickname,
            uid: userInfo.value.uid,
        }
    }
    const { avatar, nickname, uid, scores } = props.item
    return {
        score: scores,
        avatar,
        nickname,
        uid,
        index: props.index + 1,
    }
})
</script>
<style lang="scss" scoped>
.rank-peple {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    height: 114px;
    padding-right: 30px;
    background-image: linear-gradient(#40274e, #40274e), linear-gradient(#333333, #333333);
    border-radius: 16px;
    border: solid 3px #553669;
    font-size: 30px;
    color: #ffd155;

    .rank-num {
        display: flex;
        justify-content: center;
        width: 75px;
        text-align: center;
        color: #b88dcb;

        img {
            width: 46px;
            height: 59px;
        }
    }
    .rank-avatar {
        position: relative;
        margin: 0 24px 0 10px;
        width: 70px;
        height: 92px;
        padding: 2px 1px;

        &::after {
            position: absolute;
            top: 0;
            left: 0;
            content: '';
            width: 100%;
            height: 100%;
            background: url('@/assets/img/partner/rank.png') no-repeat;
            background-size: 100% 100%;
        }
        img {
            width: 100%;
            height: 100%;
            border-radius: 9px;
            object-fit: cover;
        }
    }
    .rank-name {
        flex: 1;
        max-width: 55%;
        margin: 10px;
        color: #b88dcb;
    }
    .rank-gold {
        display: flex;
        align-items: center;
    }
    &.rank-peple1,
    &.rank-peple2,
    &.rank-peple3 {
        .rank-avatar {
            &::after {
                top: -18px;
                width: 70px;
                height: 111px;
            }
        }
    }
    &.rank-peple1 {
        .rank-avatar {
            &::after {
                background-image: url('@/assets/img/partner/top-1.png');
            }
        }
        .rank-name {
            color: #ffd155;
        }
    }
    &.rank-peple2 {
        .rank-avatar {
            &::after {
                background-image: url('@/assets/img/partner/top-2.png');
            }
        }
        .rank-name {
            color: #b2daff;
        }
    }
    &.rank-peple3 {
        .rank-avatar {
            &::after {
                background-image: url('@/assets/img/partner/top-3.png');
            }
        }
        .rank-name {
            color: #ffa664;
        }
    }
}
</style>
